<template>
  <div class="excel-export-container">
    <el-page-header content="核对异常数据导出" />
    <el-card class="export-card" shadow="hover">
      <div class="query-section">
        <el-form :inline="true" class="export-query-form">
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-download"
              @click="exportCheckExceptionExcel"
              :loading="isExporting"
            >
              导出核对异常数据（5个Sheet）
            </el-button>
          </el-form-item>
        </el-form>
        <div class="export-tip">
          <i class="el-icon-info"></i>
          温馨提示：本次导出为核对异常数据，共包含 5 个工作表，导出格式为 .xlsx，数据实时从数据库查询，导出过程请耐心等待。<br/>
          <span style="color:#f56c6c;font-size:12px;">若未自动下载，请检查浏览器是否拦截了下载弹窗</span>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import service from '@/utils/request'

export default {
  name: 'CheckExceptionExport',
  data() {
    return {
      isExporting: false
    }
  },
  methods: {
    async exportCheckExceptionExcel() {
      this.isExporting = true
      try {
        const response = await service.get(
          'excel/export/check-exception',
          {
            timeout: 600000,
            responseType: 'blob',
            headers: {
              'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            }
          }
        )

        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        })

        if (blob.size < 100) {
          this.$message.error('核对异常数据导出失败：后端返回空文件，无有效数据');
          return;
        }

        const now = new Date()
        const timeStr = now.getFullYear() +
          (now.getMonth() + 1).toString().padStart(2, '0') +
          now.getDate().toString().padStart(2, '0') +
          now.getHours().toString().padStart(2, '0') +
          now.getMinutes().toString().padStart(2, '0') +
          now.getSeconds().toString().padStart(2, '0')
        const fileName = `核对异常数据_5个Sheet_${timeStr}.xlsx`

        const downloadUrl = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = downloadUrl
        link.download = fileName
        link.style.visibility = 'hidden'
        document.body.appendChild(link)
        link.dispatchEvent(new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        }))

        setTimeout(() => {
          document.body.removeChild(link)
          window.URL.revokeObjectURL(downloadUrl)
        }, 2000)

        setTimeout(() => {
          if (document.querySelector(`a[href="${downloadUrl}"]`) === null) {
            window.open(downloadUrl, '_blank')
          }
        }, 1000)

        this.$message.success('核对异常数据（5个Sheet）导出成功！若未自动下载，请检查浏览器下载弹窗拦截～')

      } catch (error) {
        console.error('核对异常数据导出错误：', error);
        if (error.response) {
          this.$message.error(`导出失败：接口返回${error.response.status}错误`);
        } else if (error.request) {
          this.$message.error('导出失败：网络异常，未收到后端响应');
        } else {
          this.$message.error(`导出失败：${error.message || '未知错误'}`);
        }
      } finally {
        this.isExporting = false
      }
    }
  }
}
</script>

<style scoped>
.excel-export-container {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: calc(100vh - 120px);
}
.export-card {
  padding: 30px;
}
.query-section {
  margin-bottom: 20px;
}
.export-query-form {
  margin-bottom: 15px;
}
.export-tip {
  padding: 10px 15px;
  background-color: #e6f7ff;
  border-radius: 6px;
  color: #1890ff;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.6;
}
.export-tip .el-icon-info {
  margin-right: 8px;
  font-size: 16px;
  vertical-align: middle;
}
</style>